import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
	selector: 'app-enable-mfasplash',
	templateUrl: './enable-mfasplash.component.html',
	styleUrls: ['./enable-mfasplash.component.scss']
})
export class EnableMfasplashComponent implements OnInit {

	constructor(private router: Router) { }

	ngOnInit(): void {
	}

	registerTwoFactor() {
		this.router.navigate(['enableMFA']);
	}

}
